import { useId, useMemo } from 'react'
import { Navigation, Pagination, A11y } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/swiper-react'
import { cn } from 'lib/utils'
import type { SliderProps } from 'components/molecules/Slider/types'

import './index.scss'
import 'swiper/swiper.css'
import 'swiper/modules/navigation.css'
import 'swiper/modules/pagination.css'

const mainClass = 'slider'

const SWIPER_CONTAINER_CLASS = 'swiper-container'
const DEFAULT_SLIDES_PER_VIEW = 1
const DEFAULT_SPACE_BETWEEN = 0

export const Slider = ({
  slidesPerView = DEFAULT_SLIDES_PER_VIEW,
  spaceBetween = DEFAULT_SPACE_BETWEEN,
  breakpoints,
  grabCursor = true,
  navigation = true,
  pagination = true,
  children,
  className = '',
  variableWidth = false,
  centerInsufficientSlides = false,
}: SliderProps) => {
  const slides = useMemo(
    () => (Array.isArray(children) ? children : [children]),
    [children]
  )
  const paginationId = useId()

  const paginationConfig = useMemo(() => {
    if (pagination) {
      return { clickable: true, el: `.swiper-pagination-${paginationId}` }
    }

    return pagination
  }, [pagination])

  const slidesPerViewValue = variableWidth ? 'auto' : slidesPerView

  return (
    <div className={cn(mainClass, className)}>
      <Swiper
        modules={[Navigation, Pagination, A11y]}
        slidesPerView={slidesPerViewValue}
        spaceBetween={spaceBetween}
        navigation={navigation}
        pagination={paginationConfig}
        grabCursor={grabCursor}
        breakpoints={breakpoints}
        className={SWIPER_CONTAINER_CLASS}
        watchOverflow={true}
        centerInsufficientSlides={centerInsufficientSlides}
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>{slide}</SwiperSlide>
        ))}
      </Swiper>
      {pagination && (
        <div
          className={`swiper-pagination swiper-pagination-${paginationId}`}
        />
      )}
    </div>
  )
}
